'use client';
import {FiMail, FiTrash2} from 'react-icons/fi';
import {IoIosShareAlt} from 'react-icons/io';
import Button from '../Button';
import {IHomeShortlistModal} from '@/dictionaries/components/modals/types';

interface IShortlistFooterProps {
  dict: IHomeShortlistModal;
  setCurrentPage: React.Dispatch<
    React.SetStateAction<'default' | 'enquiry' | 'sendToFriend'>
  >;
  handleClearShortList: () => void;
}

export const ShortlistFooter: React.FC<IShortlistFooterProps> = ({
  dict,
  setCurrentPage,
  handleClearShortList,
}) => {
  return (
    <div className="w-full bg-white tablet:sticky bottom-0 mt-[50px] tablet:mt-0 shadow-[0_-10px_20px_0_rgba(0,0,0,0.1)]">
      <div className="flex flex-col tablet:flex-row items-center justify-between max-w-default h-fit px-4 tablet:px-10 desktop:px-20 mx-auto space-x-16 py-5 gap-5">
        <div className="flex flex-col desktop:flex-row h-fit w-full flex-1 gap-0 desktop:gap-8">
          <button
            onClick={() => setCurrentPage('sendToFriend')}
            className="flex flex-row items-center space-x-2 text-primary uppercase h-full min-w-52 my-1">
            <IoIosShareAlt className={'w-5 h-5'} />
            <strong className="text-gray-900 whitespace-nowrap tracking-wide">
              {dict.buttons.sendToFriend}
            </strong>
          </button>

          <button
            onClick={handleClearShortList}
            className="flex flex-row items-center space-x-2 text-primary uppercase h-full w-full tablet:min-w-52 tablet:w-min my-1">
            <FiTrash2 className={'w-5 h-5'} />
            <strong className="text-gray-900 whitespace-nowrap tracking-wide">
              {dict.buttons.deleteShortlsit}
            </strong>
          </button>
        </div>

        <Button
          variant={'unanimated'}
          onClick={() => setCurrentPage('enquiry')}
          className="flex flex-row w-auto !ml-0 tablet:!ml-auto items-center space-x-2">
          <FiMail className="w-6 h-6" />
          <span>{dict.buttons.sendShortList}</span>
        </Button>
      </div>
    </div>
  );
};
